import React from 'react';
import { Card, CardBody, CardHeader, Col, Input, Label, Row } from 'reactstrap';

const Summary = ({ data }) => {
    return (
        <React.Fragment>
            <Row>
                <Col md={9}>
                    <Card>
                        <CardBody>
                            <div className="text-muted">
                                <h6 className="mb-3 fw-bold text-uppercase">Resumen</h6>
                                <p><span className='fw-bold'>Titulo: </span>{data.title}</p>
                                <p><span className='fw-bold'>Descripción: </span>{data.summary}</p>

                                <div className="pt-3 border-top border-top-dashed mt-4">
                                    <h6 className="mb-3 fw-bold text-uppercase">Obligación</h6>
                                    <p>{data.obligation.name}</p>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card className='card-height-100'>
                        <CardBody>
                            <div className="text-muted">
                                <h6 className="mb-3 fw-bold text-uppercase">Entidad Supervisora</h6>
                                <p>{data?.supervisory_entity?.map((entity, index) => entity.name).join(', ')}</p>

                                <h6 className="mb-3 fw-bold text-uppercase">Área Responsable</h6>
                                <p>{data?.management?.map((entity, index) => entity.name).join(', ')}</p>

                                <h6 className="mb-3 fw-bold text-uppercase">Tipo de Evidencia</h6>
                                <p>{data?.evidence_type.name}</p>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default Summary;